@if (!Loaded) {
<div class="ga-loading">{{ Loading ? 'Running the group analysis…' : 'No data.' }}</div>
} @else {

<!-- ============== Top bar: what's open + re-run + save ============== -->
<div class="ga-topbar">
  <div class="ga-title">
    @if (reportTitle) {
    <div class="ga-groups">{{ reportTitle }}</div>
    <div class="ga-sub ga-names">{{ Header?.GroupNames }}</div>
    } @else {
    <div class="ga-groups">{{ Header?.GroupNames }}</div>
    }
    <div class="ga-sub">
      {{ Header?.SkusInAnalysis }} of {{ Header?.SkuCount }} SKUs in the analysis
      @if (Header?.SkusNotActive) { · {{ Header?.SkusNotActive }} not active }
      @if (Header?.SkusExcluded) { · {{ Header?.SkusExcluded }} excluded }
      · burn {{ Header?.BurnRange }}-month average to {{ Header?.BurnWindowEnd | date:'MMM d, y':'UTC' }}
      · SAFS {{ Header?.SafsValue }}{{ Header?.SafsType === 'PCT' ? '%' : ' bags' }}
      @if (Header?.IsTestMode) { · <span class="ga-test">Test mode</span> }
    </div>
  </div>
  <div class="ga-actions">
    @if (!Embedded) {<div class="ga-burn">
      <rms-select name="gaBurnRange" label="Burn range" [options]="BurnRangeOptions"
                  [(ngModel)]="Filters.BurnRange" (ngModelChange)="queueRefresh()" [disabled]="Loading"></rms-select>
    </div>}
    <button mat-stroked-button (click)="load()" [disabled]="Loading">
      <mat-icon>refresh</mat-icon>{{ Loading ? 'Running…' : 'Re-run' }}
    </button>
    <button mat-flat-button class="btn-bg-green" (click)="saveForecast()" [disabled]="Saving || Loading">
      <mat-icon>bookmark_add</mat-icon>{{ Saving ? 'Saving…' : 'Save forecast' }}
    </button>
    <button mat-stroked-button (click)="ShowPurchaseSheet = !ShowPurchaseSheet"><mat-icon>receipt_long</mat-icon>Purchase status sheet</button>
    <span class="live-status" role="status">{{ Loading ? 'Updating…' : 'Live' }} · {{ UpdatedAt | date:'h:mm:ss a' }}</span>
  </div>
</div>

<section class="simulation-planner" aria-label="Purchase simulations">
  <div class="simulation-toolbar">
    <h3>Purchase simulations <span>bags</span></h3>
    @if (SimulationMonths.length > 12) {
    <div class="simulation-range">
      <button type="button" aria-label="Previous simulation months" (click)="changeSimulationMonths(-1)" [disabled]="SimulationMonthOffset === 0"><mat-icon>chevron_left</mat-icon></button>
      <span>{{ VisibleSimulationMonths[0]?.MonthStart | date:'MMM yy':'UTC' }} – {{ VisibleSimulationMonths[VisibleSimulationMonths.length - 1]?.MonthStart | date:'MMM yy':'UTC' }}</span>
      <button type="button" aria-label="Next simulation months" (click)="changeSimulationMonths(1)" [disabled]="SimulationMonthOffset + 12 >= SimulationMonths.length"><mat-icon>chevron_right</mat-icon></button>
    </div>
    }
    <button type="button" class="simulation-clear" (click)="clearSimulations()" [disabled]="!Simulations.length" aria-label="Clear simulations">Clear</button>
  </div>
  <div class="simulation-scroll"><table>
    <colgroup><col class="simulation-site-col" />@for (m of VisibleSimulationMonths; track m.MonthStart) {<col />}</colgroup>
    <thead><tr><th scope="col">WHSE</th>@for (m of VisibleSimulationMonths; track m.MonthStart) {<th scope="col">{{ m.MonthStart | date:'MMM':'UTC' }} <small>{{ m.MonthStart | date:'yy':'UTC' }}</small></th>}</tr></thead>
    <tbody>@for (site of SimulationSites; track site.label) {
      <tr [class.simulation-nj]="site.id === 37" [class.simulation-wi]="site.id === 31" [class.simulation-fl]="site.id === 45">
        <th scope="row" [title]="site.id === null ? 'Unallocated purchases · affect ALL only' : site.label">{{ site.id === null ? 'ALL' : site.label }}</th>
        @for (m of VisibleSimulationMonths; track m.MonthStart) {
        <td [class.simulation-entered]="simulationValue(site.id, m.MonthStart)"><input type="number" min="0" max="9999999" step="1" [attr.aria-label]="site.label + ' purchases ' + (m.MonthStart | date:'MMM yyyy':'UTC')"
          [ngModel]="simulationValue(site.id, m.MonthStart)" (ngModelChange)="editSimulation(site.id, m.MonthStart, $event)" placeholder="—" /></td>
        }
      </tr>
    }</tbody>
  </table></div>
  <div class="simulation-footer"><span>Enter arrivals by month · warehouse entries roll into ALL.</span><b>{{ SimulationTotal | number }} bags simulated</b></div>
</section>

@if (Header?.SkusInAnalysis === 0) {
<div class="data-warning"><mat-icon>info</mat-icon>No SKUs have burn or reserves in the selected window. Use the SKU picker below to include stock explicitly, or check the group's setup and burn range.</div>
}

<div class="add-sku">
  <rms-search-select name="gaAddSku" label="Add SKU to analysis" [options]="SkuOptions" labelKey="Label" valueKey="InventoryTypeID" [(ngModel)]="AddedSku"></rms-search-select>
  <button mat-flat-button class="btn-bg-green" (click)="addSku()" [disabled]="!AddedSku || Loading"><mat-icon>add</mat-icon>Add SKU</button>
</div>

@if (ShowPurchaseSheet) {
<section class="purchase-planner"><div class="planner-heading"><div><h3>Purchase status sheet · {{ Header?.GroupNames }}</h3><p>Current forecast, including simulated purchases. All quantities are bags.</p></div><button mat-stroked-button (click)="exportPurchaseSheet()"><mat-icon>download</mat-icon>Export CSV</button></div>
  <div class="planner-scroll"><table><thead><tr><th>Warehouse</th><th>Month</th><th>Opening</th><th>Sold arrivals</th><th>Unsold arrivals</th><th>Proposed</th><th>Goal</th><th>Closing</th></tr></thead>
  <tbody>@for (w of Warehouses; track w._key) {@for (m of Data?.Waterfall; track $index) {@if (m.WarehouseID === w.WarehouseID) {
    <tr><th>{{ w.WarehouseName }}</th><td>{{ m.MonthStart | date:'MMM yy':'UTC' }}</td><td>{{ m.OpeningBags | number:'1.0-0' }}</td><td>{{ m.ArrivalsSold | number:'1.0-0' }}</td><td>{{ m.ArrivalsUnsold | number:'1.0-0' }}</td><td>{{ m.SimulationBags || 0 | number:'1.0-0' }}</td><td>{{ m.GoalBags | number:'1.0-1' }}</td><td [class.neg]="m.ClosingBags < 0">{{ m.ClosingBags | number:'1.0-0' }}</td></tr>
  }}}</tbody></table></div>
</section>
}

<!-- ============== Exclusions / inclusions (legacy ✗ / ✓) — click a chip to undo ============== -->
@if (HasExclusions) {
<div class="ga-excl">
  @for (c of ExcludedCustomers; track c.id) {
  <button type="button" class="ex-chip ex-out" (click)="restoreCustomer(c.id)" title="Put this customer back and re-run">
    Customer excluded: {{ c.name }} <mat-icon>undo</mat-icon>
  </button>
  }
  @for (s of ExcludedSkus; track s.id) {
  <button type="button" class="ex-chip ex-out" (click)="restoreSku(s.id, 'excluded')" title="Put this SKU back and re-run">
    SKU excluded: {{ s.id }} {{ s.name }} <mat-icon>undo</mat-icon>
  </button>
  }
  @for (s of IncludedSkus; track s.id) {
  <button type="button" class="ex-chip ex-in" (click)="restoreSku(s.id, 'included')" title="Remove this inclusion and re-run">
    SKU included: {{ s.id }} {{ s.name }} <mat-icon>undo</mat-icon>
  </button>
  }
  @if (ExcludedCustomers.length + ExcludedSkus.length > 0) {
  <button type="button" class="ex-clear" (click)="clearExclusions()" [disabled]="Loading">Clear exclusions</button>
  }
  @if (IncludedSkus.length > 0) {
  <button type="button" class="ex-clear" (click)="clearInclusions()" [disabled]="Loading">Clear inclusions</button>
  }
</div>
}

<!-- ============== Warehouse picker ============== -->
<div class="wh-chips">
  @for (w of Warehouses; track w._key) {
  <button type="button" class="wh-chip" [class.active]="SelectedWh?._key === w._key" (click)="selectWarehouse(w)">
    <span class="wh-name">{{ w.WarehouseName }}</span>
    <span class="wh-cov {{ coverageClass(w.CoverageStatus) }}">
      {{ w.MonthsCovered !== null && w.MonthsCovered !== undefined ? (w.MonthsCovered + ' mo') : w.CoverageStatus }}
    </span>
  </button>
  }
</div>

<!-- ============== Legacy navy header band (follows the warehouse picked) ============== -->
<div class="ga-band">
  <div class="band-line band-main">
    <span>Spot &amp; Forward Depletion: <b>{{ DepletionText }}</b></span>
    <span class="band-dim">Spot only: {{ SpotDepletionText }}</span>
    <span class="band-dim">{{ SelectedWh?.WarehouseName }}</span>
    <span class="band-status {{ coverageClass(Band?.CoverageStatus) }}">{{ Band?.CoverageStatus }}</span>
  </div>
  <div class="band-line">
    <span>
      Additional Current Crop Purchases before Next Crop (Crop #1):
      <b [class.band-alert]="Band?.NeedBeforeCrop1 > 0">{{ Band?.NeedBeforeCrop1 | number:'1.0-0' }} bags</b>, SPOT or Nearby
    </span>
    <span class="band-sep">|</span>
    <span>Export Window: <b>{{ ExportWindowText }}</b></span>
  </div>
  <div class="band-line">
    <span>
      Projected Purchases for Next Crop (Crop #2):
      <b [class.band-alert]="Band?.NeedBeforeCrop2 > 0">{{ Band?.NeedBeforeCrop2 | number:'1.0-0' }} bags</b>
      @if (Header?.Crop2Arrival) { by {{ m(Header?.Crop2Arrival) }} for Shipment }
    </span>
    <span class="band-sep">|</span>
    <span>Avg. Days to Warehouse: <b>{{ Header?.AvgDaysToWarehouse ?? '—' }} days</b> to INSTORE</span>
  </div>
</div>

<!-- ============== KPI strip (selected warehouse) ============== -->
<div class="kpis">
  <div class="kpi">
    <div class="k-label">Burn / month</div>
    <div class="k-value">{{ Band?.BurnUsed | number:'1.0-1' }}</div>
    <div class="k-sub">3 mo {{ Band?.Burn3 | number:'1.0-0' }} · 6 mo {{ Band?.Burn6 | number:'1.0-0' }} · 12 mo {{ Band?.Burn12 | number:'1.0-0' }}</div>
  </div>
  <div class="kpi">
    <div class="k-label">Goal / month</div>
    <div class="k-value">{{ Band?.GoalBags | number:'1.0-1' }}</div>
    <div class="k-sub">burn + {{ Band?.SafsBags | number:'1.0-1' }} SAFS</div>
  </div>
  <div class="kpi">
    <div class="k-label">In store (spot)</div>
    <div class="k-value">{{ Band?.SpotOnHand | number:'1.0-0' }}</div>
    <div class="k-sub">{{ Band?.SpotReserved | number:'1.0-0' }} reserved · {{ Band?.SpotUnsold | number:'1.0-0' }} unsold</div>
  </div>
  <div class="kpi">
    <div class="k-label">Forward</div>
    <div class="k-value">{{ Band?.ForwardBags | number:'1.0-0' }}</div>
    <div class="k-sub">{{ Band?.ForwardUnsold | number:'1.0-0' }} unsold · next {{ (d(Band?.NextArrival) | date:'MMM d') ?? '—' }}</div>
  </div>
  <div class="kpi">
    <div class="k-label">Months covered</div>
    <div class="k-value">{{ Band?.MonthsCovered ?? '—' }}</div>
    <div class="k-sub">order by {{ (d(Band?.OrderByDate) | date:'MMM d, y') ?? '—' }}</div>
  </div>
  <div class="kpi">
    <div class="k-label">New crop</div>
    <div class="k-value k-small">{{ (d(Header?.Crop1Arrival) | date:'MMM d, y') ?? '—' }}</div>
    <div class="k-sub">crop #2 {{ (d(Header?.Crop2Arrival) | date:'MMM d, y') ?? '—' }}</div>
  </div>
  <div class="kpi">
    <div class="k-label">Month to date</div>
    <div class="k-value">{{ Header?.MtdBags | number:'1.0-0' }}</div>
    <div class="k-sub">
      last year {{ Header?.MtdLastYearBags | number:'1.0-0' }}
      @if (MtdChangePct !== null) { ({{ MtdChangePct > 0 ? '+' : '' }}{{ MtdChangePct }}%) }
    </div>
  </div>
</div>

@if (SelectedWh?.ActionNeeded && SelectedWh.ActionNeeded !== 'N/A') {
<div class="wh-line">
  <span class="wh-spot">Spot status: <b>{{ SelectedWh.SpotStatus }}</b></span>
  <span class="wh-action">{{ SelectedWh.ActionNeeded }}</span>
</div>
}

<!-- ============== Chart + Top 15 burners ============== -->
<div class="ga-chart-row">
  <div class="ga-chart">
    <div class="chart-head">
      <span class="chart-title">Projected bags left at month end — {{ SelectedWh?.WarehouseName }}</span>
      <span class="chart-legend">
        <span class="lg"><i class="sw sw-bar"></i>Bags left</span>
        <span class="lg"><i class="sw sw-short"></i>Short</span>
        <span class="lg"><i class="sw sw-arr"></i>Arriving</span>
        <span class="lg"><i class="sw sw-crop"></i>New crop</span>
        <span class="lg"><i class="sw sw-goal"></i>1 month's goal ({{ SelectedWh?.GoalBags | number:'1.0-0' }})</span>
      </span>
    </div>
    <svg [attr.viewBox]="'0 0 ' + ChartW + ' ' + ChartH" preserveAspectRatio="none" role="img"
         aria-label="Projected bags left at the end of each month, with bags arriving">
      <!-- gridlines + y labels -->
      @for (t of ChartTicks; track $index) {
      <line class="grid" [attr.x1]="ChartPadL" [attr.x2]="ChartW - 8" [attr.y1]="t.y" [attr.y2]="t.y"></line>
      <text class="ylab" [attr.x]="ChartPadL - 6" [attr.y]="t.y + 4">{{ t.label }}</text>
      }
      <!-- bars -->
      @for (b of ChartBars; track $index) {
      <g class="bar-g">
        <rect [class.short]="b.short" [attr.x]="b.x" [attr.y]="b.y" [attr.width]="b.w" [attr.height]="b.h"
              [attr.rx]="b.w > 8 ? 3 : 1">
          <title>{{ b.label }}: {{ b.value | number:'1.0-0' }} bags left{{ b.short ? ' (short)' : '' }}{{ b.crop ? ' — ' + b.cropLabel : '' }}</title>
        </rect>
        <text class="xlab" [attr.x]="b.x + b.w / 2" [attr.y]="ChartH - 8">{{ b.label }}</text>
      </g>
      }
      <!-- zero line -->
      <line class="zero" [attr.x1]="ChartPadL" [attr.x2]="ChartW - 8" [attr.y1]="ChartZeroY" [attr.y2]="ChartZeroY"></line>
      <!-- one month's goal — named in the legend (no label in the plot, so it never overlaps) -->
      @if (ChartGoalY !== null) {
      <line class="goal" [attr.x1]="ChartPadL" [attr.x2]="ChartW - 8" [attr.y1]="ChartGoalY" [attr.y2]="ChartGoalY">
        <title>1 month's goal: {{ SelectedWh?.GoalBags | number:'1.0-0' }} bags</title>
      </line>
      }
      <!-- new-crop line(s) with the bags left that month -->
      @for (b of ChartBars; track $index) {
      @if (b.crop) {
      <line class="crop" [attr.x1]="b.x + b.w / 2" [attr.x2]="b.x + b.w / 2" [attr.y1]="ChartPadT - 4" [attr.y2]="ChartH - ChartPadB"></line>
      <text class="crop-lab" [attr.x]="b.x + b.w / 2 + 4" [attr.y]="ChartPadT + 2">{{ b.cropLabel }}: {{ b.value | number:'1.0-0' }}</text>
      }
      }
      <!-- arrivals line (yellow) -->
      @if (ArrivalPoints) {
      <polyline class="arr-line" [attr.points]="ArrivalPoints"></polyline>
      @for (p of ArrivalDots; track $index) {
      @if (p.value > 0) {
      <circle class="arr-dot" [attr.cx]="p.x" [attr.cy]="p.y" r="3">
        <title>{{ p.label }}: {{ p.value | number:'1.0-0' }} bags arriving</title>
      </circle>
      }
      }
      }
    </svg>
  </div>

  <!-- Top N bag burners (legacy panel) — ✗ excludes and re-runs -->
  <div class="ga-top">
    <div class="top-head">Top {{ TopBurners.length }} bag burners</div>
    <div class="top-list">
      @for (c of TopBurners; track c.CompanyID) {
      <div class="top-row">
        <span class="top-rank">{{ c.BurnRank }}</span>
        <span class="top-name" [title]="c.CompanyName">{{ c.CompanyName }}</span>
        <span class="top-burn">{{ c.BurnUsed | number:'1.0-0' }}</span>
        <button type="button" class="top-x" title="Exclude this customer and re-run"
                (click)="excludeCustomer(c)" [disabled]="Loading">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      } @empty {
      <div class="tab-note">No pickups in the burn window.</div>
      }
    </div>
    <div class="top-foot">bags / month · {{ Header?.BurnRange }}-month average</div>
  </div>
</div>

<!-- ============== Summary details — month by month (selected warehouse) ============== -->
<div class="waterfall">
  <table>
    <thead>
      <tr>
        <th class="sticky">Month</th>
        @for (m of Waterfall; track m.MonthIndex) {
        <th [class.crop]="m.IsCrop" [title]="m.CropLabel">{{ m.Label }}@if (m.IsCrop) {<span class="nc">{{ m.CropLabel }}</span>}</th>
        }
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="sticky">Opening bags</td>
        @for (m of Waterfall; track m.MonthIndex) {
        <td [class.crop]="m.IsCrop">{{ m.Opening | number:'1.0-0' }}</td> }
      </tr>
      <tr>
        <td class="sticky">+ Arriving (sold)</td>
        @for (m of Waterfall; track m.MonthIndex) {
        <td [class.crop]="m.IsCrop" class="muted">{{ m.ArrSold ? (m.ArrSold | number:'1.0-0') : '' }}</td> }
      </tr>
      <tr>
        <td class="sticky">+ Arriving (unsold)</td>
        @for (m of Waterfall; track m.MonthIndex) {
        <td [class.crop]="m.IsCrop" class="muted">{{ m.ArrUnsold ? (m.ArrUnsold | number:'1.0-0') : '' }}</td> }
      </tr>
      <tr>
        <td class="sticky">− Goal (burn + SAFS)</td>
        @for (m of Waterfall; track m.MonthIndex) {
        <td [class.crop]="m.IsCrop" class="muted">{{ m.Goal | number:'1.0-1' }}</td> }
      </tr>
      <tr class="closing">
        <td class="sticky">= Goal surplus / deficit</td>
        @for (m of Waterfall; track m.MonthIndex) {
        <td [class.crop]="m.IsCrop" [class.neg]="m.Closing < 0"
            [class.low]="m.Closing >= 0 && m.Closing < (m.Goal ?? 0)">
          {{ m.Closing | number:'1.0-0' }}
        </td>
        }
      </tr>
    </tbody>
  </table>
</div>

<!-- ============== Detail tabs ============== -->
<rms-tab-group>

  <rms-tab label="Customers ({{ Customers.length }})">
    <ng-template>
      <p class="tab-note">✗ excludes a customer from the burn and re-runs the analysis (undo with the chip at the top).</p>
      <rms-table [HeaderButtons]="CustomerButtons" [parentContext]="this" [data]="Customers"
                 [columns]="CustomerColumns" [getIcons]="getCustomerIcons" tableId="ews-ga-customers"
                 [customizable]="true" startSort="BurnRank" startSortDirection="asc"></rms-table>
    </ng-template>
  </rms-tab>

  <rms-tab label="SKUs ({{ Header?.SkusInAnalysis }} / {{ Skus.length }})">
    <ng-template>
      <div class="sku-bar">
        <span class="tab-note">✗ takes a SKU out of the analysis · ✓ adds a not-active SKU in · each re-runs.</span>
        @if (ExcludedSkus.length) {
        <button type="button" class="ex-clear" (click)="clearSkuExclusions()" [disabled]="Loading">Clear SKU exclusions</button>
        }
        @if (IncludedSkus.length) {
        <button type="button" class="ex-clear" (click)="clearInclusions()" [disabled]="Loading">Clear inclusions</button>
        }
      </div>
      @if (SkuTotals) {
      <div class="sku-totals">
        <span class="st-label">Grand totals ({{ SkuTotals.Count }} SKUs in the analysis)</span>
        <span>Burn / mo <b>{{ SkuTotals.BurnUsed | number:'1.0-1' }}</b></span>
        <span>In store sold <b>{{ SkuTotals.SpotSold | number:'1.0-0' }}</b></span>
        <span>In store unsold <b>{{ SkuTotals.SpotUnsold | number:'1.0-0' }}</b></span>
        <span>Forward sold <b>{{ SkuTotals.ForwardSold | number:'1.0-0' }}</b></span>
        <span>Forward unsold <b>{{ SkuTotals.ForwardUnsold | number:'1.0-0' }}</b></span>
        <span>On reserve <b>{{ SkuTotals.OnReserve | number:'1.0-0' }}</b></span>
      </div>
      }
      <rms-table [HeaderButtons]="SkuButtons" [parentContext]="this" [data]="Skus"
                 [columns]="SkuColumns" [getIcons]="getSkuIcons" tableId="ews-ga-skus"
                 [customizable]="true"></rms-table>
    </ng-template>
  </rms-tab>

  <rms-tab label="Arrivals ({{ Arrivals.length }})">
    <ng-template>
      <rms-table [HeaderButtons]="ArrivalButtons" [parentContext]="this" [data]="Arrivals"
                 [columns]="ArrivalColumns" tableId="ews-ga-arrivals" [customizable]="true"
                 startSort="EstArrival" startSortDirection="asc"></rms-table>
    </ng-template>
  </rms-tab>

  <rms-tab label="Freight">
    <ng-template>
      <p class="tab-note">
        Last {{ Freight.length }} freight times to the warehouse for these SKUs —
        average <b>{{ Header?.AvgDaysToWarehouse ?? '—' }} days</b> to INSTORE.
        (The new-crop date uses the origin country average: {{ Header?.CropFreightDays ?? '—' }} days.)
      </p>
      <rms-table [parentContext]="this" [data]="Freight" [columns]="FreightColumns"
                 tableId="ews-ga-freight" [IncludePaginator]="false"></rms-table>
    </ng-template>
  </rms-tab>

  <rms-tab label="Burn History">
    <ng-template>
      <p class="tab-note">Annual monthly burn rate (bags ÷ 12) · current year = year-to-date bags ÷ months so far.</p>
      <table class="simple">
        <thead>
          <tr><th>Year</th><th>Bags picked up</th><th>Customers</th><th>Monthly burn rate</th><th>Year before</th><th>Change</th></tr>
        </thead>
        <tbody>
          @for (y of BurnByYear; track y.Year) {
          <tr>
            <td>{{ y.Year }}@if (y.IsYearToDate) { <span class="ytd">YTD to {{ y.ThroughDate | date:'MMM d':'UTC' }}</span> }</td>
            <td>{{ y.Bags | number:'1.0-0' }}</td>
            <td>{{ y.Customers }}</td>
            <td><b>{{ y.MonthlyRate | number:'1.1-1' }}</b></td>
            <td>{{ y.CompareRate === null ? '—' : (y.CompareRate | number:'1.1-1') }}</td>
            <td [class.up]="y.PctChange > 0" [class.down]="y.PctChange < 0">
              {{ y.PctChange === null ? '—' : ((y.PctChange > 0 ? '+' : '') + y.PctChange + '%') }}
            </td>
          </tr>
          }
        </tbody>
      </table>
    </ng-template>
  </rms-tab>

  <rms-tab label="Notes ({{ Notes.length }})">
    <ng-template>
      @if (!SingleGroupID) {
      <p class="tab-note">Notes are kept per group — open a single group to add notes.</p>
      } @else {
      <div class="note-form">
        <div class="nf-type">
          <rms-select name="gaNoteType" label="Type" [options]="NoteTypeOptions" [(ngModel)]="NewNoteType"></rms-select>
        </div>
        <div class="nf-date">
          <rms-date name="gaNoteFollowUp" label="Follow-up date" [(ngModel)]="NewNoteFollowUp"></rms-date>
        </div>
        <div class="nf-text">
          <rms-textarea name="gaNoteText" label="Note" [(ngModel)]="NewNoteText"></rms-textarea>
        </div>
        <button mat-flat-button class="btn-bg-green" (click)="addNote()"
                [disabled]="SavingNote || !NewNoteText.trim()">
          <mat-icon>add</mat-icon>Add note
        </button>
      </div>

      @for (n of Notes; track n.NoteID) {
      <div class="note">
        <div class="note-head">
          <span class="note-type">{{ n.NoteType }}</span>
          <span>{{ n.InsertedByName ?? 'Unknown' }} · {{ n.InsertedDate | date:'MMM d, y h:mm a':'UTC' }}</span>
          @if (n.UpdatedDate && n.UpdatedDate !== n.InsertedDate) { <span class="muted">edited</span> }
          @if (n.FollowUpDate) { <span class="follow">Follow up {{ d(n.FollowUpDate) | date:'MMM d, y' }}</span> }
          <button type="button" class="note-del" title="Delete note" (click)="deleteNote(n)"><mat-icon>delete</mat-icon></button>
        </div>
        <div class="note-text">{{ n.NoteText }}</div>
      </div>
      } @empty {
      <p class="tab-note">No notes yet.</p>
      }
      }
    </ng-template>
  </rms-tab>

</rms-tab-group>
}
